module.exports = __webpack_public_path__ + "img/combined_shape.a4efa48c.svg";